/* eslint-disable sort-keys */
import {TCharacteristicList} from 'modules/product-card/types';
import {COUNTRY, MANUFACTURER, PREMIUM_PACK, REGION} from 'modules/product-card/constants/characteristics';

const HEADER = [COUNTRY, REGION, MANUFACTURER, PREMIUM_PACK];
const DETAILED: TCharacteristicList = [];
const TABLET = [...HEADER, ...DETAILED];

export const AKSESSUARY_CHARACTERISTICS = {
    HEADER,
    DETAILED,
    TABLET,
};
